import React from "react";

// Official Senior Benefit Advisors brand asset: gold umbrella mark + navy
// "SENIOR BENEFIT ADVISORS" wordmark. Do not recreate or alter the mark.
// light=true renders the cream wordmark variant for dark/navy surfaces.
const NAVY_WORDMARK = `${process.env.PUBLIC_URL || ""}/brand/sba-navy-wordmark.png`;
const CREAM_WORDMARK = `${process.env.PUBLIC_URL || ""}/brand/sba-cream-wordmark.png`;

export function SBALogo({ className, light = false }) {
  return (
    <img
      src={light ? CREAM_WORDMARK : NAVY_WORDMARK}
      alt="Senior Benefit Advisors"
      className={`block w-auto object-contain max-w-full ${className || "h-10 sm:h-12"}`}
      data-testid="nav-brand-logo"
    />
  );
}
